module.exports = "<div ng-if=$ctrl.experimentsLoaded> <ng-transclude></ng-transclude> </div> ";